// IE 2026 10 19 / ODOO-5800 (Igor 19.10, дословно: «давай упростим процесс согласования КАМ…МД до аля булевого: "на согласовании" >> "согласован"; и тогда в отчётах
// со страниц 13–18 выводить булевые колонки о согласовании с изменением статуса при клике на них и наоборот … показать как в М03 (кол. 6–8: группа «Затверджено»
// с колонками ПМ · БЮМ · МД, флажки) и добавь "КАМ"; показывать можем во всех отчётах со страниц 13–18, а давать возможность изменения только в соответствующих»).
// Булевы флажки согласования уровней планов (страницы ieXPL_customer / market / portfolio / company / consensus / budget стола 0af_001, источник DS-PLAN-LEVEL-DOCS):
// колонки approved_customer / approved_market / approved_portfolio / approved_company (группа «Approved»: KAM · PM · BUM · MD, AttrBool) — документ уровня
// SALES-PLAN-<уровень>-<версия> утверждён; служебная колонка approved_partial (текст: уровни через запятую, у которых под ключом строки утверждена ЧАСТЬ
// документов — считает DS: КАМ-документы под SKU × страна на странице PM и т.п.). Чистая логика без Vue / wijmo (юнит — tests/unit/planFlags.test.mjs):
//   1. итог строки-группы по колонке флажка — ЖИВЬЁМ по листьям её поддерева (строки грида в памяти, несохранённые значения тоже): все ✓ → ✓, ни одного (и нет
//      частичных) → пусто, иначе — полузаполненный чекбокс (как approvalPartialLive для M03, но по дереву группировки DL2: ключ отбора у группы и у листа разный,
//      поэтому «документы» группы — листья её поддерева, а не строки с тем же ключом); лист с частичным агрегатом DS (approved_partial) — полузаполненный;
//   2. каскад при клике по флажку строки-группы: та же отметка на все листья поддерева (set_value каждого — в стек правок, уходят одним Save; бэк plan_flags
//      переводит статусы документов уровня страницы); редактируемость чужих колонок режут правила CF записи виджета (isReadOnly), бэк проверяет уровень страницы.
// Отличие от M03-флажков (utils/m03Flags.js): уровни независимы (порядка шагов ПМ → БЮМ → МД нет, каждая колонка — свой документ), каскад — по поддереву, не по измерениям.
// Выключатель fe.ux.planFlags (дефолт ВКЛ; выкл — как до правки: итог группы = «any» бэка, каскада нет). Крючки — AttrGrid.vue: approvalFlagPartial_of, set_value → planFlags_afterEdit.

export const PLAN_FLAGS_FLAG = 'fe.ux.planFlags'
// колонка флажка → уровень документов; порядок — как в группе «Approved» (KAM · PM · BUM · MD)
export const PLAN_FLAG_FIELDS = ['approved_customer', 'approved_market', 'approved_portfolio', 'approved_company']
export const PLAN_FLAG_LEVELS = { approved_customer: 'customer', approved_market: 'market', approved_portfolio: 'portfolio', approved_company: 'company' }
export const PLAN_FLAG_PARTIAL = 'approved_partial'

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
const str = (x) => (x === undefined || x === null) ? '' : String(x)
const FLAG_BINDING_PREFIX = /^(doc\.data\.|data::|data\.|doc\.)/
const TAB_KINDS = ['tab', 'tabrow', 'tabcol', 'tabheader']
const skipRow = (x) => !isObj(x) || !!x._variant || (isObj(x._DLRow) && (TAB_KINDS.includes(str(x._DLRow.row_type)) || !!x._DLRow.memo))
const lvl = (r) => { const n = Number(r && r.level); return Number.isFinite(n) ? n : 0 }

// setting — функция (key, default) → значение (AttrGrid: fmtSetting / store.setting); нет функции / ошибка — ВКЛ
export function planFlags_on(setting) {
    try { return typeof setting !== 'function' || setting(PLAN_FLAGS_FLAG, true) !== false } catch (e) { return true }
}
// поле флажка из привязки колонки ('approved_market' / 'data::approved_market' / '2026-01-01.approved_market' → 'approved_market'); не флажок — ''
export function planFlagField(binding) {
    const b = str(binding), m = FLAG_BINDING_PREFIX.exec(b)
    let f = b.slice(m ? m[0].length : 0)
    const i = f.lastIndexOf('.')
    if (i >= 0) f = f.slice(i + 1)
    return PLAN_FLAG_FIELDS.includes(f) ? f : ''
}
// уровень документов колонки флажка ('customer' | 'market' | 'portfolio' | 'company'); не флажок — ''
export function planFlagLevel(binding) { return PLAN_FLAG_LEVELS[planFlagField(binding)] || '' }
// привязки колонок флажков из списка привязок грида, по порядку уровней
export function planFlagBindings(bindings) {
    if (!Array.isArray(bindings)) return []
    const out = bindings.filter(b => planFlagField(b))
    out.sort((a, b) => PLAN_FLAG_FIELDS.indexOf(planFlagField(a)) - PLAN_FLAG_FIELDS.indexOf(planFlagField(b)))
    return out.filter((b, i) => out.indexOf(b) === i)
}
// значение флажка истинно (как у живого итога M03: true / 1 / 'true' / {value})
export function planFlagTrue(v) {
    if (isObj(v)) v = v.value
    if (typeof v === 'string') return ['true', '1', 'yes', 'on'].includes(v.trim().toLowerCase())
    return v === true || v === 1
}
// у строки-листа под ключом утверждена ЧАСТЬ документов уровня колонки (служебная колонка DS approved_partial: 'customer,market' …)
export function planFlagPartialOf(dataItem, binding, read) {
    const level = planFlagLevel(binding)
    if (!level || typeof read !== 'function') return false
    let v = read(dataItem, PLAN_FLAG_PARTIAL)
    if (isObj(v)) v = v.value
    if (v === undefined || v === null || v === '') return false
    return str(v).split(/[,\s]+/).map(s => s.trim().toLowerCase()).includes(level)
}
// листья поддерева строки rows[irow] ({level, dataItem} по порядку: wijmo RowCollection либо массив — только length и индекс): строки глубже irow до первой
// строки уровня ≤ своего, у которых следующая строка не глубже (нет детей); служебные строки (вкладки / memo / варианты) — мимо. → [{irow, dataItem}]
export function planFlagLeaves(rows, irow) {
    const out = []
    if (!rows || typeof rows !== 'object' || !(rows.length >= 0)) return out
    const R = rows[irow]
    if (!R) return out
    const lv = lvl(R)
    for (let i = irow + 1; i < rows.length; i++) {
        const r = rows[i], l = lvl(r)
        if (l <= lv) break
        const n = rows[i + 1]
        if (n && lvl(n) > l) continue   // есть дети — не лист
        const x = r ? r.dataItem : null
        if (!x || skipRow(x)) continue
        out.push({ irow: i, dataItem: x })
    }
    return out
}
// живой итог строки rows[irow] по колонке флажка binding: {approved, total, state: 'all' | 'none' | 'part'} либо null (не флажок / строка-лист без частичного
// агрегата — обычная ячейка). read(dataItem, binding) — живое значение (несохранённое тоже)
export function planFlagPartial(rows, irow, binding, read) {
    if (!planFlagField(binding) || typeof read !== 'function') return null
    const R = rows && typeof rows === 'object' ? rows[irow] : null, it = R ? R.dataItem : null
    if (!it || skipRow(it)) return null
    const leaves = planFlagLeaves(rows, irow)
    if (!leaves.length) return planFlagPartialOf(it, binding, read) && !planFlagTrue(read(it, binding)) ? { approved: 0, total: 0, state: 'part' } : null
    let approved = 0, part = 0
    for (const l of leaves) {
        if (planFlagTrue(read(l.dataItem, binding))) approved++
        else if (planFlagPartialOf(l.dataItem, binding, read)) part++
    }
    const total = leaves.length
    return { approved, total, state: approved === total ? 'all' : (!approved && !part ? 'none' : 'part') }
}
// ячейка флажка заперта бэком (мета строки / ячейки _DLRow) — каскад её не трогает
export function planFlagCellLocked(dataItem, binding) {
    const dl = isObj(dataItem) ? dataItem._DLRow : null
    if (!isObj(dl)) return false
    if (dl.isReadOnly === true) return true
    const c = isObj(dl.cells) ? dl.cells[binding] : null
    return isObj(c) && c.isReadOnly === true
}
// цели каскада при клике по флажку строки rows[irow] (установка и снятие симметричны): листья поддерева, у которых значение ещё не want и ячейка не заперта;
// canSet(dataItem, irow) — дополнительный отказ (правило CF / замок). → [{irow, dataItem}]; [] — строка-лист (каскада нет) / не флажок
export function planFlagCascadeTargets(rows, irow, binding, read, want, canSet) {
    if (!planFlagField(binding) || typeof read !== 'function') return []
    const w = planFlagTrue(want)
    return planFlagLeaves(rows, irow).filter(t => planFlagTrue(read(t.dataItem, binding)) !== w && !planFlagCellLocked(t.dataItem, binding)
        && (typeof canSet !== 'function' || canSet(t.dataItem, t.irow)))
}
